import { styled } from 'styled-components'
import { Link } from 'react-router'
import { onMediumScreen } from 'mixtiles-web-common'

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 36px 21px 39px;
  background: ${({ theme }) => theme.colors.white};

  ${onMediumScreen()} {
    gap: 80px;
    padding: 120px clamp(40px, calc(100% * 120 / 1280), 120px);
  }
`

export const Title = styled.h2`
  margin: 0;
  font-size: 32px;
  line-height: 1.1;
  font-weight: 600;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};

  ${onMediumScreen()} {
    font-size: 40px;
    line-height: 1.2;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
  max-width: 348px;

  ${onMediumScreen()} {
    /* One row: every product gets an equal column. */
    grid-template-columns: none;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    gap: 24px;
    max-width: 1440px;
  }
`

export const Card = styled(Link)`
  position: relative;
  display: block;
  aspect-ratio: 166 / 204;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  background: linear-gradient(180deg, #faf7ef 0%, #e6e3dc 100%);

  ${onMediumScreen()} {
    aspect-ratio: 458 / 581;
    border-radius: 24px;
  }
`

export const CardImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const CardScrim = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 50%,
    rgba(0, 0, 0, 0.34) 100%
  );
`

export const CardLabel = styled.span`
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white};
  text-shadow:
    0px 4px 13px rgba(43, 5, 20, 0.04),
    0px 3px 4px rgba(43, 5, 20, 0.07);

  ${onMediumScreen()} {
    /* Figma: 72px above the bottom of the 581px-tall card. */
    bottom: calc(100% * 72 / 581);
    padding-inline: 16px;
    font-size: 24px;
  }
`
